import { TranslationKey, translationKey } from 'intl/types/translationKey';

/**
 * AUTO-GENERATED — do not edit manually.
 * Run `yarn generate:translation-keys` after changing messages.en.json.
 */
export const FiltersTranslationKeys = {
  discardFilters: translationKey('discard_filters'),
  discardFiltersDescription: translationKey('discard_filters_description'),
  actionFilter: translationKey('filters_action_filter'),
  activeIssues: translationKey('filters_active_issues'),
  clearAll: translationKey('filters_clear_all'),
  clickSaveHint: translationKey('filters_click_save_hint'),
  collapsePresets: translationKey('filters_collapse_presets'),
  countLabel: translationKey('filters_count_label'),
  createNewPreset: translationKey('filters_create_new_preset'),
  createPresetTitle: translationKey('filters_create_preset_title'),
  currentPreset: translationKey('filters_current_preset'),
  discardChanges: translationKey('filters_discard_changes'),
  errorDateFromBeforeTo: translationKey('filters_error_dateFromBeforeTo'),
  errorDateToBeforeFrom: translationKey('filters_error_dateToBeforeFrom'),
  expandPresets: translationKey('filters_expand_presets'),
  filterTypeAssignee: translationKey('filters_filter_type_assignee'),
  filterTypeCreatedBy: translationKey('filters_filter_type_created_by'),
  filterTypeCreationDate: translationKey('filters_filter_type_creation_date'),
  filterTypeDateFromLabel: translationKey('filters_filter_type_date_from_label'),
  filterTypeDateToLabel: translationKey('filters_filter_type_date_to_label'),
  filterTypeDetectionDate: translationKey('filters_filter_type_detection_date'),
  filterTypeProcess: translationKey('filters_filter_type_process'),
  filterTypeSite: translationKey('filters_filter_type_site'),
  filterTypeStage: translationKey('filters_filter_type_stage'),
  filterTypeSubcontractor: translationKey('filters_filter_type_subcontractor'),
  groupAdd: translationKey('filters_group_add'),
  groupAddCondition: translationKey('filters_group_add_condition'),
  noSavedPresets: translationKey('filters_no_saved_presets'),
  operatorContains: translationKey('filters_operator_contains'),
  operatorDateRange: translationKey('filters_operator_date_range'),
  operatorIs: translationKey('filters_operator_is'),
  operatorIsEmpty: translationKey('filters_operator_is_empty'),
  operatorIsNot: translationKey('filters_operator_is_not'),
  operatorIsNotApplicable: translationKey('filters_operator_is_not_applicable'),
  operatorIsNotEmpty: translationKey('filters_operator_is_not_empty'),
  operatorNotInDateRange: translationKey('filters_operator_not_in_date_range'),
  overwritePreset: translationKey('filters_overwrite_preset'),
  presetAssignedToMe: translationKey('filters_preset_assigned_to_me'),
  presetDeadline7Days: translationKey('filters_preset_deadline_7_days'),
  presetNameLabel: translationKey('filters_preset_name_label'),
  presetPredefined: translationKey('filters_preset_predefined'),
  presetReportedByMe: translationKey('filters_preset_reported_by_me'),
  removedIssues: translationKey('filters_removed_issues'),
  renamePresetTitle: translationKey('filters_rename_preset_title'),
  resetLabel: translationKey('filters_reset_label'),
  resultsLabel: translationKey('filters_results_label'),
  saveAsNew: translationKey('filters_save_as_new'),
  saveChanges: translationKey('filters_save_changes'),
  saveCurrentFilters: translationKey('filters_save_current_filters'),
  savedPresetsTitle: translationKey('filters_saved_presets_title'),
  title: translationKey('filters_title'),
  unsavedChanges: translationKey('filters_unsaved_changes'),
  unsavedCloseMessage: translationKey('filters_unsaved_close_message'),
  unsavedCloseTitle: translationKey('filters_unsaved_close_title'),
} as const satisfies Record<string, TranslationKey>;
